var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// jscpd:ignore-start
import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Button, IconButton, MenuItem, Autocomplete, TextField } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos, Settings } from '@mui/icons-material';
import InputDados from '../../../components/input_dados';
import ContainerPainel from '../../../components/container_painel';
import { BoxPrincipal } from '../../../components/grid_box';
import { PaginationModelDefault } from '../../../components/grid';
import { getAnosReferencia, getMascaraMoeda, getFloat } from '../../../utils';
import { FUNCIONALIDADES, PAGINAS } from '../../../routes';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { GridFolhaBase } from '../components/GridFolhaBase';
import { calcularTotaisFolhaMensal } from './folhas_mensais.utils';
import { adicionarLancamentoManual, getCombosListar, getFolhasMensais, removerLancamentoManual, abrirFolhaPagamento, fecharFolhaPagamento, validarFechamentoFolha, getInstituicoesPorAno, getContratosPorInstituicao, getPeriodosPorAno, buscarColaboradores, STATUS_API, getRelatorioFolha, getResumoFolha, getRelatorioAusentes, getRelatorioContrato, } from './folhas_mensais.service';
export var FolhasMensaisListar = function () {
    // NOSONAR
    var _a = useState(true), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(true), isLoadingInicio = _b[0], setIsLoadingInicio = _b[1];
    var _c = useState(), folhasPagamentoMes = _c[0], setFolhasPagamentoMes = _c[1];
    var _d = useState([]), folhasRegistros = _d[0], setFolhasRegistros = _d[1];
    var _f = useState([]), instituicoesDisponiveis = _f[0], setInstituicoesDisponiveis = _f[1];
    var _g = useState([]), rublicasDisponiveis = _g[0], setRublicasDisponiveis = _g[1];
    var _h = useState([]), tiposRegimesDisponiveis = _h[0], setTiposRegimesDisponiveis = _h[1];
    var anosDisponiveis = useState(getAnosReferencia())[0];
    var _j = useState([]), periodosDisponiveis = _j[0], setPeriodosDisponiveis = _j[1];
    var _k = useState(new Date().getFullYear()), buscaAnoReferencia = _k[0], setBuscaAnoReferencia = _k[1];
    var _l = useState(-1), buscaInstituicao = _l[0], setBuscaInstituicao = _l[1];
    var _m = useState(-1), buscaPeriodo = _m[0], setBuscaPeriodo = _m[1];
    var _o = useState(-1), buscaTipoRegime = _o[0], setBuscaTipoRegime = _o[1];
    var _p = useState(new Date().getMonth() + 1), buscaMesReferencia = _p[0], setBuscaMesReferencia = _p[1];
    var _q = useState(-1), buscaReeducando = _q[0], setBuscaReeducando = _q[1];
    var _r = useState(-1), buscaContrato = _r[0], setBuscaContrato = _r[1];
    var _s = useState([]), contratosDisponiveis = _s[0], setContratosDisponiveis = _s[1];
    var _t = useState([]), colaboradorOptions = _t[0], setColaboradorOptions = _t[1];
    var _u = useState(''), colaboradorInput = _u[0], setColaboradorInput = _u[1];
    var _v = useState(null), colaboradorSelecionado = _v[0], setColaboradorSelecionado = _v[1];
    var _w = useState(0), totalProventos = _w[0], setTotalProventos = _w[1];
    var _x = useState(0), totalDescontos = _x[0], setTotalDescontos = _x[1];
    var _y = useState(0), totalTaxas = _y[0], setTotalTaxas = _y[1];
    var _z = useState(0), totalLiquido = _z[0], setTotalLiquido = _z[1];
    var _0 = useState(0), totalRegistros = _0[0], setTotalRegistros = _0[1];
    var _1 = useState(PaginationModelDefault), paginationModel = _1[0], setPaginationModel = _1[1];
    var _2 = useState(false), folhaAdmin = _2[0], setFolhaAdmin = _2[1];
    var _3 = useState(0), forceRender = _3[0], setForceRender = _3[1];
    var _4 = useState(false), desabilitarCampos = _4[0], setDesabilitarCampos = _4[1];
    var triggerReRender = function () { return setForceRender(function (prev) { return prev + 1; }); };
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var acoesFuncionalidade = getAcoesFuncionalidade(FUNCIONALIDADES.FOLHAS_MENSAIS);
    var calcularValoresCorretos = function (row, override) { return calcularTotaisFolhaMensal(row, override); };
    useEffect(function () {
        carregarDados();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel]);
    useEffect(function () {
        if (isLoadingInicio) {
            setIsLoadingInicio(false);
        }
        else {
            setPaginationModel(function (prev) { return (__assign(__assign({}, prev), { page: 0 })); });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [buscaAnoReferencia, buscaMesReferencia, buscaInstituicao, buscaTipoRegime, buscaReeducando, buscaContrato, buscaPeriodo]);
    useEffect(function () {
        carregarDadosAuxiliares();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var carregar = function () { return __awaiter(void 0, void 0, void 0, function () {
            var resp, respPeriodos;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getInstituicoesPorAno(buscaAnoReferencia)];
                    case 1:
                        resp = _a.sent();
                        setInstituicoesDisponiveis(Array.isArray(resp) ? resp : []);
                        return [4 /*yield*/, getPeriodosPorAno(buscaAnoReferencia)];
                    case 2:
                        respPeriodos = _a.sent();
                        setPeriodosDisponiveis(Array.isArray(respPeriodos) ? respPeriodos : []);
                        return [2 /*return*/];
                }
            });
        }); };
        carregar();
        setBuscaInstituicao(-1);
        setBuscaContrato(-1);
        setBuscaPeriodo(-1);
        setContratosDisponiveis([]);
        setColaboradorSelecionado(null);
        setColaboradorOptions([]);
        setBuscaReeducando(-1);
    }, [buscaAnoReferencia]);
    useEffect(function () {
        var carregar = function () { return __awaiter(void 0, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(buscaInstituicao && buscaInstituicao !== -1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getContratosPorInstituicao(buscaInstituicao, buscaAnoReferencia)];
                    case 1:
                        resp = _a.sent();
                        setContratosDisponiveis(Array.isArray(resp) ? resp : []);
                        return [3 /*break*/, 3];
                    case 2:
                        setContratosDisponiveis([]);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        carregar();
        setBuscaContrato(-1);
        setColaboradorSelecionado(null);
        setColaboradorOptions([]);
        setBuscaReeducando(-1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [buscaInstituicao]);
    useEffect(function () {
        if (!Array.isArray(folhasRegistros))
            return;
        var p = 0, d = 0, t = 0, l = 0;
        folhasRegistros.forEach(function (item) {
            var v = calcularValoresCorretos(item);
            p += v.proventos;
            d += v.descontos;
            t += v.taxas;
            l += v.liquido;
        });
        setTotalProventos(p);
        setTotalDescontos(d);
        setTotalTaxas(t);
        setTotalLiquido(l);
    }, [folhasRegistros]);
    var handleBuscarColaboradores = function (texto) { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!texto || texto.trim().length < 3) {
                        setColaboradorOptions([]);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, buscarColaboradores(texto, buscaInstituicao)];
                case 1:
                    resp = _a.sent();
                    setColaboradorOptions(Array.isArray(resp) ? resp : []);
                    return [2 /*return*/];
            }
        });
    }); };
    var carregarDadosAuxiliares = function () { return __awaiter(void 0, void 0, void 0, function () {
        var acoesAdmin, comboListar;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    acoesAdmin = getAcoesFuncionalidade(FUNCIONALIDADES.FOLHA_ADMIN);
                    setFolhaAdmin(!!(acoesAdmin === null || acoesAdmin === void 0 ? void 0 : acoesAdmin['VISUALIZAR']));
                    return [4 /*yield*/, getCombosListar()];
                case 1:
                    comboListar = _a.sent();
                    if ((comboListar === null || comboListar === void 0 ? void 0 : comboListar.Status) !== STATUS_API.ERRO) {
                        setTiposRegimesDisponiveis(comboListar.tipos_regimes);
                        setRublicasDisponiveis(comboListar.rubricas);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resposta, dados, total_registros;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(buscaAnoReferencia && buscaMesReferencia && buscaInstituicao && buscaInstituicao !== -1))
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, getFolhasMensais(buscaAnoReferencia.toString(), buscaMesReferencia.toString(), buscaInstituicao.toString(), buscaTipoRegime === -1 ? null : buscaTipoRegime.toString(), buscaReeducando === -1 ? null : buscaReeducando.toString(), buscaContrato === -1 ? null : buscaContrato.toString(), paginationModel, buscaPeriodo === -1 ? null : buscaPeriodo.toString())];
                case 1:
                    resposta = _b.sent();
                    if ((resposta === null || resposta === void 0 ? void 0 : resposta.Status) === STATUS_API.ERRO) {
                        alert(resposta.Mensagem);
                    }
                    else if (resposta) {
                        dados = resposta.dados, total_registros = resposta.total_registros;
                        setFolhasPagamentoMes(dados);
                        setFolhasRegistros((dados === null || dados === void 0 ? void 0 : dados.registros) || []);
                        setDesabilitarCampos(((_a = dados === null || dados === void 0 ? void 0 : dados.situacao) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'FECHADA');
                        setTotalRegistros(total_registros);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    var alterarMes = function (direcao) {
        var m = buscaMesReferencia + direcao;
        var a = buscaAnoReferencia;
        if (m > 12) {
            a += 1;
            m = 1;
        }
        if (m < 1) {
            a -= 1;
            m = 12;
        }
        if (anosDisponiveis.some(function (item) { return item.value === a; })) {
            setBuscaAnoReferencia(a);
            setBuscaMesReferencia(m);
        }
    };
    var adicionarLancamento = function (contrato_id, rubrica_id, valor) { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!contrato_id || !rubrica_id || !valor)
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, adicionarLancamentoManual(contrato_id, rubrica_id, getFloat(valor), buscaAnoReferencia, buscaMesReferencia)];
                case 1:
                    resp = _a.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        carregarDados();
                        triggerReRender();
                    }
                    else {
                        alert(resp ? resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var removerLancamento = function (_contrato_id, lancamento) { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm('Deseja realmente remover o lançamento?'))
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, removerLancamentoManual(lancamento.id)];
                case 1:
                    resp = _a.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        carregarDados();
                        triggerReRender();
                    }
                    else {
                        alert(resp ? resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var downloadRelatorioReeducando = function (contrato_id) { return __awaiter(void 0, void 0, void 0, function () {
        var doc, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, getRelatorioContrato(contrato_id.toString(), buscaAnoReferencia.toString(), buscaMesReferencia.toString())];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        link = document.createElement('a');
                        link.href = doc;
                        link.download = "relatorio_reeducando_".concat(contrato_id, ".pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(doc);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var downloadRelatorioFolha = function () { return __awaiter(void 0, void 0, void 0, function () {
        var doc, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, getRelatorioFolha(buscaAnoReferencia.toString(), buscaMesReferencia.toString(), buscaInstituicao !== -1 ? buscaInstituicao.toString() : null, buscaTipoRegime !== -1 ? buscaTipoRegime.toString() : null, buscaReeducando !== -1 ? buscaReeducando.toString() : null, buscaContrato !== -1 ? buscaContrato.toString() : null)];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        link = document.createElement('a');
                        link.href = doc;
                        link.download = "relatorio_folha_".concat(buscaAnoReferencia, "_").concat(buscaMesReferencia, ".pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(doc);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var downloadResumoFolha = function () { return __awaiter(void 0, void 0, void 0, function () {
        var doc, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, getResumoFolha(buscaAnoReferencia.toString(), buscaMesReferencia.toString(), buscaInstituicao !== -1 ? buscaInstituicao.toString() : null, buscaTipoRegime !== -1 ? buscaTipoRegime.toString() : null, buscaReeducando !== -1 ? buscaReeducando.toString() : null, buscaContrato !== -1 ? buscaContrato.toString() : null)];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        link = document.createElement('a');
                        link.href = doc;
                        link.download = "resumo_folha_".concat(buscaAnoReferencia, "_").concat(buscaMesReferencia, ".pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(doc);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var downloadRelatorioAusentes = function () { return __awaiter(void 0, void 0, void 0, function () {
        var doc, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, getRelatorioAusentes(buscaAnoReferencia.toString(), buscaMesReferencia.toString(), buscaInstituicao !== -1 ? buscaInstituicao.toString() : null, buscaTipoRegime !== -1 ? buscaTipoRegime.toString() : null)];
                case 1:
                    doc = _a.sent();
                    if (doc) {
                        link = document.createElement('a');
                        link.href = doc;
                        link.download = "relatorio_ausentes_".concat(buscaAnoReferencia, "_").concat(buscaMesReferencia, ".pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(doc);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var alterarSituacaoFolha = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp_1, validacao, mensagem, resp;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!((folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.situacao) === 'Fechada')) return [3 /*break*/, 2];
                    if (!confirm('Deseja realmente reabrir a folha de pagamento deste período?'))
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, abrirFolhaPagamento(buscaMesReferencia, buscaAnoReferencia)];
                case 1:
                    resp_1 = _c.sent();
                    if ((resp_1 === null || resp_1 === void 0 ? void 0 : resp_1.Status) === 'OK') {
                        alert('Situação da folha alterada com sucesso');
                        carregarDados();
                    }
                    else {
                        alert(resp_1 ? resp_1.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
                case 2:
                    setIsLoading(true);
                    return [4 /*yield*/, validarFechamentoFolha(buscaInstituicao)];
                case 3:
                    validacao = _c.sent();
                    if (((_a = validacao === null || validacao === void 0 ? void 0 : validacao.erros) !== null && _a !== void 0 ? _a : []).length > 0) {
                        setIsLoading(false);
                        alert("Erro: ".concat(validacao.erros.join('\n')));
                        return [2 /*return*/];
                    }
                    setIsLoading(false);
                    mensagem = 'A folha de pagamento será fechada impossibilitando edição. Deseja continuar?';
                    if (((_b = validacao === null || validacao === void 0 ? void 0 : validacao.avisos) !== null && _b !== void 0 ? _b : []).length > 0)
                        mensagem = "Aten\u00E7\u00E3o: ".concat(validacao.avisos.join('\n'), "\n\n").concat(mensagem);
                    if (totalLiquido < 0)
                        mensagem = "Aten\u00E7\u00E3o: o l\u00EDquido total deste per\u00EDodo est\u00E1 NEGATIVO (".concat(getMascaraMoeda(totalLiquido), ").\n\n").concat(mensagem);
                    if (!confirm(mensagem))
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, fecharFolhaPagamento(buscaMesReferencia, buscaAnoReferencia)];
                case 4:
                    resp = _c.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        alert('Folha de pagamento fechada com sucesso');
                        carregarDados();
                    }
                    else {
                        alert(resp ? resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var MesSelecaoComp = (_jsxs(Box, __assign({ display: 'flex', alignItems: 'center' }, { children: [_jsx(IconButton, __assign({ onClick: function () { return alterarMes(-1); } }, { children: _jsx(ArrowBackIos, {}) })), _jsx(Typography, __assign({ variant: 'h6' }, { children: "".concat(meses[buscaMesReferencia - 1], " - ").concat(buscaAnoReferencia) })), _jsx(IconButton, __assign({ onClick: function () { return alterarMes(1); } }, { children: _jsx(ArrowForwardIos, {}) })), (folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.situacao) && (_jsx(IconButton, __assign({ onClick: folhaAdmin ? alterarSituacaoFolha : function () { return alert('Sem permissão'); } }, { children: _jsxs(Typography, __assign({ variant: 'body2', ml: 1, color: 'textSecondary' }, { children: [folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.situacao, " \uD83D\uDD12"] })) })))] })));
    var getOptionLabel = function (o) {
        if (!o)
            return '';
        return o.cpf ? "".concat(o.nome, " \u2022 CPF: ").concat(o.cpf) : o.nome;
    };
    return (_jsx(ContainerPainel, __assign({ pagina: PAGINAS.FOLHAS_MENSAIS, pagina_especifica_permissao: FUNCIONALIDADES.FOLHAS_MENSAIS }, { children: !isLoadingInicio && (_jsxs(BoxPrincipal, __assign({ width: '90%' }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2, mb: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsx(InputDados, __assign({ select: true, id: 'ano_referencia', label: 'Ano de Refer\u00EAncia', value: buscaAnoReferencia, onChange: function (e) { return setBuscaAnoReferencia(e.target.value); } }, { children: anosDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.value }, { children: item.label }), item.value)); }) })) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'instituicao', label: 'Institui\u00E7\u00E3o', value: buscaInstituicao, onChange: function (e) { return setBuscaInstituicao(e.target.value); } }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Selecione..." })), instituicoesDisponiveis === null || instituicoesDisponiveis === void 0 ? void 0 : instituicoesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item === null || item === void 0 ? void 0 : item.dados.razao_social }), item.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'contrato_termo', label: 'Contrato/Termo', value: buscaContrato, onChange: function (e) { return setBuscaContrato(e.target.value); }, disabled: !buscaInstituicao || buscaInstituicao === -1 }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Todos" })), contratosDisponiveis === null || contratosDisponiveis === void 0 ? void 0 : contratosDisponiveis.map(function (item) { return _jsx(MenuItem, __assign({ value: item.id }, { children: "N\u00BA ".concat(item.numero_termo_contrato) }), item.id); })] })) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'regime_reclusao', label: 'Tipo de Regime', value: buscaTipoRegime, onChange: function (e) { return setBuscaTipoRegime(e.target.value); } }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Selecione..." })), tiposRegimesDisponiveis === null || tiposRegimesDisponiveis === void 0 ? void 0 : tiposRegimesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item === null || item === void 0 ? void 0 : item.nome }), item.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 6 }, { children: _jsx(Autocomplete, { id: 'colaborador-busca', options: colaboradorOptions, value: colaboradorSelecionado, inputValue: colaboradorInput, getOptionLabel: getOptionLabel, onChange: function (_e, val) {
                                    setColaboradorSelecionado(val);
                                    setBuscaReeducando(val ? val.id : -1);
                                }, onInputChange: function (_e, val) {
                                    setColaboradorInput(val);
                                    handleBuscarColaboradores(val);
                                }, noOptionsText: colaboradorInput.trim().length < 3 ? 'Digite ao menos 3 caracteres' : 'Nenhum colaborador encontrado', renderInput: function (params) { return _jsx(TextField, __assign({}, params, { label: 'Colaborador (Nome / CPF / Matr\u00EDcula)', size: 'small', fullWidth: true })); } }) })), _jsx(Grid, __assign({ item: true, xs: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'periodo', label: 'Per\u00EDodo', value: buscaPeriodo, onChange: function (e) { return setBuscaPeriodo(e.target.value); } }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Selecione..." })), periodosDisponiveis === null || periodosDisponiveis === void 0 ? void 0 : periodosDisponiveis.map(function (item) { return _jsx(MenuItem, __assign({ value: item.id }, { children: "Dia ".concat(item.dia_inicio, " a ").concat(item.dia_fim) }), item.id); })] })) })), (folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.situacao) === 'Aberta' && (_jsx(Grid, __assign({ item: true, xs: 3, display: 'flex', alignItems: 'center' }, { children: _jsx(Button, __assign({ variant: 'contained', color: 'success', startIcon: _jsx(Settings, {}), onClick: alterarSituacaoFolha, disabled: !folhaAdmin, sx: { height: 40 } }, { children: "Gerar Fechamento" })) })))] })), buscaInstituicao && buscaInstituicao !== -1 && (folhasPagamentoMes === null || folhasPagamentoMes === void 0 ? void 0 : folhasPagamentoMes.calculada) ? (_jsx(GridFolhaBase, { folhasRegistros: folhasRegistros, totalProventos: totalProventos, totalDescontos: totalDescontos, totalTaxas: totalTaxas, totalLiquido: totalLiquido, totalRegistros: totalRegistros, isLoading: isLoading, paginationModel: paginationModel, setPaginationModel: setPaginationModel, forceRender: forceRender, desabilitarCampos: desabilitarCampos, folhaAdmin: folhaAdmin, acoesFuncionalidade: acoesFuncionalidade, rublicasDisponiveis: rublicasDisponiveis, mesSelecaoComp: MesSelecaoComp, downloadRelatorioFolha: downloadRelatorioFolha, downloadResumoFolha: downloadResumoFolha, downloadRelatorioAusentes: downloadRelatorioAusentes, downloadRelatorioReeducando: downloadRelatorioReeducando, adicionarLancamento: adicionarLancamento, removerLancamento: removerLancamento, calcularValoresCorretos: calcularValoresCorretos })) : (_jsxs(Box, __assign({ p: 2, pt: 5, mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', sx: { backgroundColor: '#f9f9f9', borderRadius: 2, textAlign: 'center', padding: 4 } }, { children: [MesSelecaoComp, _jsx(Typography, __assign({ variant: 'body1', gutterBottom: true, mt: 3 }, { children: !buscaInstituicao || buscaInstituicao === -1
                                ? 'Selecione uma instituição para visualizar os dados'
                                : 'A folha referente a este período ainda não foi calculada.' })), _jsx(Button, __assign({ variant: 'contained', color: 'success', onClick: alterarSituacaoFolha, sx: { textTransform: 'none', padding: '8px 16px', marginTop: 5 }, disabled: !folhaAdmin || !buscaInstituicao || buscaInstituicao === -1 }, { children: "Calcular folha" }))] })))] }))) })));
};
export default FolhasMensaisListar;
